/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Fragment } from "react";
// import DisplayTextOnly from 'cms/fields/_partials/display/display-text-only'
import DisplayTextOnlyWrapper from "cms/fields/layout/controls/display-text-wrapper";
import { useCurrentDynamicField } from "cms/fields/dynamic-field";
import { FieldDisplayWrapper } from "cms/fields/layout/field-display-wrapper";
import { isArrayNotEmpty, isStringNotEmpty } from "utils/empty-exists";

const MultiLineFieldDisplay = () => {
    
    const { field } = useCurrentDynamicField();
    const { values } = field || {};
    
    return (
        <FieldDisplayWrapper>
            {isArrayNotEmpty(values) &&
                values.map((item, index) => {
                    const { value, settings } = item || {};
                    const { style } = settings || {};
                    let parts = [];
                    if (isStringNotEmpty(value)) {
                        parts = value.split("\n");
                    }
                    return (
                        <Fragment key={index}>
                            {isArrayNotEmpty(parts) &&
                                parts.map((part,index) => {
                                    return (
                                        <DisplayTextOnlyWrapper
                                            key={index}
                                            style={style}
                                        >
                                            <span key={index}>{part}<br/></span>
                                        </DisplayTextOnlyWrapper>
                                    );
                                })
                            }
                        </Fragment>
                    );
                })}
        </FieldDisplayWrapper>
    );
};
MultiLineFieldDisplay.displayName = "MultiLineFieldDisplay";
export { MultiLineFieldDisplay };
